/* MBG Tabbed Content Therapies — the tab switcher.
   Loaded only when the section renders more than one tab.

   The template already renders every pane and every image, so a tap only flips
   attributes: no request, no decode, no image layout. The panes use the hidden
   attribute, the images only their opacity class, which keeps the swap on the
   compositor. */
(function () {
    var ROOT_SELECTOR = '[data-mbg-tct]';
    var TAB_SELECTOR = '[data-mbg-tct-tab]';
    var PICTURE_ACTIVE = 'mbg-tabbed-therapies__picture--active';

    function init(root) {
        if (root.dataset.mbgTctReady === 'true') return;

        var tabs = root.querySelectorAll(TAB_SELECTOR);
        var panes = root.querySelectorAll('[data-mbg-tct-pane]');
        if (tabs.length < 2 || panes.length !== tabs.length) return;

        /* Blocks without an image render no picture, so the index comes from the
           attribute here instead of the position. */
        var pictures = root.querySelectorAll('[data-mbg-tct-picture]');

        root.dataset.mbgTctReady = 'true';

        function activate(index, focus) {
            if (index < 0 || index >= tabs.length) return;

            for (var t = 0; t < tabs.length; t++) {
                tabs[t].setAttribute('aria-selected', t === index ? 'true' : 'false');
                tabs[t].tabIndex = t === index ? 0 : -1;
            }

            for (var p = 0; p < panes.length; p++) {
                panes[p].hidden = p !== index;
            }

            for (var i = 0; i < pictures.length; i++) {
                var shown = Number(pictures[i].getAttribute('data-mbg-tct-picture')) === index;
                pictures[i].classList[shown ? 'add' : 'remove'](PICTURE_ACTIVE);
                pictures[i].setAttribute('aria-hidden', shown ? 'false' : 'true');
            }

            if (focus) tabs[index].focus();
        }

        /* Exposed for the theme editor, which selects a block outside this scope. */
        root.mbgTctActivate = activate;

        function indexOf(tab) {
            return Array.prototype.indexOf.call(tabs, tab);
        }

        function onClick(event) {
            activate(indexOf(event.currentTarget), false);
        }

        /* Roving tabindex — the arrow keys move the selection, so only the active
           tab stays in the tab order. */
        function onKeydown(event) {
            var current = indexOf(event.currentTarget);
            var next = -1;

            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                next = (current + 1) % tabs.length;
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                next = (current - 1 + tabs.length) % tabs.length;
            } else if (event.key === 'Home') {
                next = 0;
            } else if (event.key === 'End') {
                next = tabs.length - 1;
            }

            if (next < 0) return;

            event.preventDefault();
            activate(next, true);
        }

        for (var i = 0; i < tabs.length; i++) {
            tabs[i].addEventListener('click', onClick);
            tabs[i].addEventListener('keydown', onKeydown);
        }
    }

    function initAll(scope) {
        var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            init(roots[i]);
        }
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });

    /* Selecting a tab block in the editor opens it, otherwise the merchant would
       edit a pane that is not on screen. */
    document.addEventListener('shopify:block:select', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var tab = target.closest(TAB_SELECTOR);
        if (!tab) return;

        var root = tab.closest(ROOT_SELECTOR);
        if (!root || !root.mbgTctActivate) return;

        root.mbgTctActivate(Number(tab.getAttribute('data-mbg-tct-tab')), false);
    });
})();
